import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Tabs } from 'antd'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Update } from './Update'
import { Import } from './Import'
interface ICSVProduct {
  sku: string
  lowStock: number
  restock: number
}

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  onClose: () => void
  onSave: () => void
}

interface State {
  tab: 'update' | 'import'
  products?: ICSVProduct[]
}

@inject('currentCompanyStore')
@observer
export class LowStockModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      tab: 'update',
    }
  }

  render() {
    return (
      <Modal
        visible={true}
        title='Update low stock/restock levels'
        onCancel={this.props.onClose}
        footer={null}
        bodyStyle={{ paddingTop: 5 }}
        maskClosable={false}
      >
        <Tabs
          activeKey={this.state.tab}
          style={{ marginBottom: 10 }}
          onChange={(key) => this.setState({ tab: key as 'update' | 'import' })}
        >
          <Tabs.TabPane tab='Update' key='update'>
            <Update onSave={this.props.onSave} />
          </Tabs.TabPane>
          <Tabs.TabPane tab='Import CSV' key='import'>
            <Import onSubmit={this.props.onSave} />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    )
  }
}
